import Consts from '../../consts/adminConsts'

export default class {
    
    Id = null;

    FullName = "";

    Rights = Consts.UserRights[1];

    Role = null;

    Post = null;

    DAX = null;

    Email = null;

    NewPassword = null;

    PhoneNumber = null;

    Status = null;

    Devices = [];

    Comment = null;

    mapFromDto = function (viewmodel) {
        let dto = viewmodel;
        
        if(!dto) return this;

        this.Id = dto.Id;
        this.FullName = dto.FullName;
        this.Rights = Consts.UserRights.find(e => e.Id == dto.Rights);
        this.Role = dto.Role;
        this.Post = dto.Post;
        this.DAX = dto.DAX;
        this.Email = dto.Email;
        this.NewPassword = dto.NewPassword;
        this.PhoneNumber = dto.PhoneNumber;
        this.Status = Consts.UserStatus.find(e => e.Id == dto.Status);

        if(dto.Devices && dto.Devices.length)
            this.Devices = dto.Devices.map(e => new Device().mapFromDto(e));

        this.Comment = dto.Comment;

        return this;
    }

    mapFromDaxUser = function(model) {
        this.FullName = model.Fio;
        this.DAX = model.Dax;
        this.Post = model.Post;
    }

    mapToDto = function () {
        let dto = JSON.parse(JSON.stringify(this));

        dto.Rights = dto.Rights.Id;
        dto.Status = dto.Status.Id;
     
        return dto;
    }

    isValid = function () {
        return Boolean(this.FullName) && 
               Boolean(this.DAX) && 
               Boolean(this.Email) &&                 
               Boolean(this.PhoneNumber) && 
               this.Rights != null &&
               this.Status != null;
    }
}

class Device {

    Id = null;

    UserId = null;

    NotificationId = null;

    Platform = null;

    AppVersion = null;

    Device = null;

    OsVersion = null;

    LastLogin = null;

    RegionCode = null;

    Branch = null;

    mapFromDto(deviceDto) {
        if(!deviceDto)
            return this;

        this.Id = deviceDto.Id;
        this.UserId = deviceDto.UserId;
        this.NotificationId = deviceDto.NotificationId;
        this.Platform = deviceDto.Platform;
        this.AppVersion = deviceDto.AppVersion;
        this.Device = deviceDto.Device;
        this.OsVersion = deviceDto.OsVersion;
        this.LastLogin = new Date(deviceDto.LastLogin);
        this.RegionCode = deviceDto.RegionCode;
        this.Branch = deviceDto.Branch;

        return this;
    }
}